/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalDetailedCoverSheetDiagnosis } from './PalDetailedCoverSheetDiagnosis';
import {
    PalDetailedCoverSheetDiagnosisFromJSON,
    PalDetailedCoverSheetDiagnosisFromJSONTyped,
    PalDetailedCoverSheetDiagnosisToJSON,
    PalDetailedCoverSheetDiagnosisToJSONTyped,
} from './PalDetailedCoverSheetDiagnosis';

/**
 * 
 * @export
 * @interface PalDetailedCoverSheet
 */
export interface PalDetailedCoverSheet {
    /**
     * 
     */
    facility_name: string | null;
    /**
     * 
     */
    facility_address: string | null;
    /**
     * 
     */
    facility_city_state_zip: string | null;
    /**
     * 
     */
    callback_phone: string | null;
    /**
     * 
     */
    callback_fax: string | null;
    /**
     * 
     */
    title: string | null;
    /**
     * YYYY-MM-DD
     */
    date: string | null;
    /**
     * Null until the submission package has been generated; filled in from the package page count at render time.
     */
    pages: number | null;
    /**
     * 
     */
    to_payer: string | null;
    /**
     * 
     */
    from: string | null;
    /**
     * 
     */
    facility_npi: string | null;
    /**
     * 
     */
    tax_id: string | null;
    /**
     * 
     */
    physician_name: string | null;
    /**
     * 
     */
    physician_npi: string | null;
    /**
     * YYYY-MM-DD
     */
    start_of_care_date: string | null;
    /**
     * 
     */
    member_name: string | null;
    /**
     * YYYY-MM-DD
     */
    member_dob: string | null;
    /**
     * 
     */
    member_number: string | null;
    /**
     * 
     */
    home_address: string | null;
    /**
     * 
     */
    home_phone: string | null;
    /**
     * 
     */
    current_facility: string | null;
    /**
     * YYYY-MM-DD
     */
    admitted_date_at_current_facility: string | null;
    /**
     * 
     */
    diagnoses: Array<PalDetailedCoverSheetDiagnosis>;
}

/**
 * Check if a given object implements the PalDetailedCoverSheet interface.
 */
export function instanceOfPalDetailedCoverSheet(value: object): value is PalDetailedCoverSheet {
    if (!('facility_name' in value) || value['facility_name'] === undefined) return false;
    if (!('facility_address' in value) || value['facility_address'] === undefined) return false;
    if (!('facility_city_state_zip' in value) || value['facility_city_state_zip'] === undefined) return false;
    if (!('callback_phone' in value) || value['callback_phone'] === undefined) return false;
    if (!('callback_fax' in value) || value['callback_fax'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('pages' in value) || value['pages'] === undefined) return false;
    if (!('to_payer' in value) || value['to_payer'] === undefined) return false;
    if (!('from' in value) || value['from'] === undefined) return false;
    if (!('facility_npi' in value) || value['facility_npi'] === undefined) return false;
    if (!('tax_id' in value) || value['tax_id'] === undefined) return false;
    if (!('physician_name' in value) || value['physician_name'] === undefined) return false;
    if (!('physician_npi' in value) || value['physician_npi'] === undefined) return false;
    if (!('start_of_care_date' in value) || value['start_of_care_date'] === undefined) return false;
    if (!('member_name' in value) || value['member_name'] === undefined) return false;
    if (!('member_dob' in value) || value['member_dob'] === undefined) return false;
    if (!('member_number' in value) || value['member_number'] === undefined) return false;
    if (!('home_address' in value) || value['home_address'] === undefined) return false;
    if (!('home_phone' in value) || value['home_phone'] === undefined) return false;
    if (!('current_facility' in value) || value['current_facility'] === undefined) return false;
    if (!('admitted_date_at_current_facility' in value) || value['admitted_date_at_current_facility'] === undefined) return false;
    if (!('diagnoses' in value) || value['diagnoses'] === undefined) return false;
    return true;
}

export function PalDetailedCoverSheetFromJSON(json: any): PalDetailedCoverSheet {
    return PalDetailedCoverSheetFromJSONTyped(json, false);
}

export function PalDetailedCoverSheetFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalDetailedCoverSheet {
    if (json == null) {
        return json;
    }
    return {
        
        'facility_name': json['facility_name'],
        'facility_address': json['facility_address'],
        'facility_city_state_zip': json['facility_city_state_zip'],
        'callback_phone': json['callback_phone'],
        'callback_fax': json['callback_fax'],
        'title': json['title'],
        'date': json['date'],
        'pages': json['pages'],
        'to_payer': json['to_payer'],
        'from': json['from'],
        'facility_npi': json['facility_npi'],
        'tax_id': json['tax_id'],
        'physician_name': json['physician_name'],
        'physician_npi': json['physician_npi'],
        'start_of_care_date': json['start_of_care_date'],
        'member_name': json['member_name'],
        'member_dob': json['member_dob'],
        'member_number': json['member_number'],
        'home_address': json['home_address'],
        'home_phone': json['home_phone'],
        'current_facility': json['current_facility'],
        'admitted_date_at_current_facility': json['admitted_date_at_current_facility'],
        'diagnoses': ((json['diagnoses'] as Array<any>).map(PalDetailedCoverSheetDiagnosisFromJSON)),
    };
}

export function PalDetailedCoverSheetToJSON(json: any): PalDetailedCoverSheet {
    return PalDetailedCoverSheetToJSONTyped(json, false);
}

export function PalDetailedCoverSheetToJSONTyped(value?: PalDetailedCoverSheet | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facility_name': value['facility_name'],
        'facility_address': value['facility_address'],
        'facility_city_state_zip': value['facility_city_state_zip'],
        'callback_phone': value['callback_phone'],
        'callback_fax': value['callback_fax'],
        'title': value['title'],
        'date': value['date'],
        'pages': value['pages'],
        'to_payer': value['to_payer'],
        'from': value['from'],
        'facility_npi': value['facility_npi'],
        'tax_id': value['tax_id'],
        'physician_name': value['physician_name'],
        'physician_npi': value['physician_npi'],
        'start_of_care_date': value['start_of_care_date'],
        'member_name': value['member_name'],
        'member_dob': value['member_dob'],
        'member_number': value['member_number'],
        'home_address': value['home_address'],
        'home_phone': value['home_phone'],
        'current_facility': value['current_facility'],
        'admitted_date_at_current_facility': value['admitted_date_at_current_facility'],
        'diagnoses': ((value['diagnoses'] as Array<any>).map(PalDetailedCoverSheetDiagnosisToJSON)),
    };
}

